export const ENTITY = "MANDATORY_REQUIREMENT";

export const MANDATORY_CATEGORY_TYPE = {
   ORGANIZATION_STATS: 'ORGANIZATION_STATS',
   OKED: 'OKED'
}